<!-- =========================================================================================
    File Name: Recommend.vue
    Description: Price Optimization Recommendation
    ----------------------------------------------------------------------------------------
    Item Name: Appyvue - Bootstrap App with PY and VUE
    Author: @nand
========================================================================================== -->
<template>
  <div id="sku-forecast">
    <!-- <pre>{{unitSelected}}</pre> -->
    <div class="vx-row">
      <div class="vx-col w-full" id="order-panel">
        <vx-card
          title="Sku list with demand prediction"
          subtitle="Use inline filters or filter button to query and include or exclude items from PO trigger">
          <!-- <pre>{{stock.res.trend[0]}}</pre> -->
          <template slot="actions">
            <!-- <feather-icon icon="MoreVerticalIcon" svgClasses="w-6 h-6"></feather-icon> -->
          </template>
          <!-- <vs-alert active="true" class="mb-1" icon-pack="feather" icon="icon-star">
            Chupa chups topping bonbon. Jelly-o toffee I love. Sweet I love wafer I love wafer.
          </vs-alert> -->
          <!-- TABLE ACTION ROW -->
          <div class="flex flex-wrap justify-between items-center">
            <!-- ITEMS PER PAGE -->
            <div class="mb-4 md:mr-4 ag-grid-table-actions-left">
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div
                  class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                >
                  <span
                    class="mr-2"
                  >{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ units.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : units.length }} of {{ units.length }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="filled" color="primary" icon-pack="feather" icon="icon-chevron-down">{{paginationPageSize > 0 ? paginationPageSize : stock.res.trend.length}} per page</vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                    <span>20</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                    <span>50</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                    <span>100</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
                    <span>150</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>

            <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
            <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
              <!-- <vs-input
                class="mb-4 md:mb-0 mr-4"
                v-model="searchQuery"
                @input="updateSearchQuery"
                placeholder="Search..."
              /> -->
              <vx-tooltip
                title="Preset Rules"
                color="warning"
                text="1. Select all skus with order quantity greater than 12 units.">

                <vs-button size="small" :color="ruleFilter.state === 'apply' ? 'primary' : 'gray'" class="mb-4 md:mb-0 mr-4" @click="actOnFilter(ruleFilter.state, '0', 'quantity_per_sku')">{{ruleFilter.label}}</vs-button>
              </vx-tooltip>
              <vs-input-number class="mb-4 md:mb-0 mr-6" v-model="serviceLevel.actual" :step="serviceLevel.step" :min="serviceLevel.min" :max="serviceLevel.max" :color="serviceLevel.intensity" :label="serviceLevel.label" @input="applyServiceLevel()"/>
              <vs-button class="mb-4 md:mb-0 mr-4" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button>
              <vs-button class="mb-4 md:mb-0 mr-4" @click="exportToExcel()">Export as XSLX</vs-button>
              
              <vs-button
                class="mb-4 md:mb-0"
                @click="popupActive=true;"
              >Order ~ <small> {{ orderValue | numFormat('$ 0,0') }} </small>
              <!-- <span class="feather-icon-badge bg-primary text-white h-5 w-5 absolute rounded-full text-xs flex items-center justify-center">{{unitSelected.length}}</span> -->
              </vs-button>
              <vs-chip color="danger" v-if="unitSelected.length > 0" class="bg-danger text-white absolute text-xs flex items-center justify-center" style="top: 15px; right: 10px">{{ unitSelected.length }}</vs-chip>
              <!-- <vs-chip color="danger" v-if="unitSelected.length > 0">{{ unitSelected.length }}</vs-chip> -->
              <!-- <feather-icon icon="ShoppingCartIcon" class="cursor-pointer ml-4 mr-6 mt-1" :badge="unitSelected.length"></feather-icon> -->
            </div>
          </div>
          <div class="flex flex-wrap justify-between items-center">
              <vs-input
                  class="w-full"
                  v-model="searchQuery"
                  @input="updateSearchQuery"
                  placeholder="Search..."
                />
            
          </div>
          <ag-grid-vue
            :gridOptions="gridOptions"
            class="ag-theme-material w-100 my-4 ag-grid-table"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :rowData="units"
            rowSelection="multiple"
            colResizeDefault="shift"
            :animateRows="true"
            :floatingFilter="true"
            :pagination="true"
            :paginationPageSize="paginationPageSize"
            :suppressPaginationPanel="true"
            @grid-ready="onGridReady"
            @selection-changed="onSelectionChanged"
          ></ag-grid-vue>
          <vs-pagination :total="totalPages" :max="maxPageNumbers" v-model="currentPage" />
        </vx-card>
      </div>
    </div>
<!-- 
    <div class="flex flex-wrap justify-between mr-5">
      <div></div>

      <vs-button
        @click="popupActive=true;$vs.notify({title:'Success',text:'Stock Order details notified to the resepective department',color:'success'})"
        color="primary"
        type="filled"
      >Trigger Stock Order</vs-button>
    </div> 
-->
    <vs-popup
      fullscreen
      background-color="rgba(255,255,255,.6)"
      :background-color-popup="colorx"
      class
      title="PO Trigger Log"
      :active.sync="popupActive"
    >
      <pobill :artefact="artefact" :service="serviceLevel" :selected="activatePopup()"></pobill>
    </vs-popup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/app/shared/components/statistics-cards/StatisticsCardLine.vue";
import analyticsData from "./analyticsData.js";
import { AgGridVue } from "ag-grid-vue";

import Pobill from "./Pobill.vue";
//{"brand": "Ragu", "case_translation": 6.0, "distributor_id": null, "long_description": "old world style ragu meat sauce", "product_category": "Condiments / Pasta Sauce / ZCat / ZCat", "quantity": 6, "quantity_in_cases": 1.0, "quantity_per_sku": 4.0, "sale_week": 44, "sale_year": 2019, "sku_id": "36200003008", "store_code": "ccb23788-2d92-11e1-8194-0015c5e16c09"}
export default {
  props: {
    artefact: { type: Object, required: true }
  },
  data() {
    return {
      orderValue: 0,
      serviceLevel: {
        label: "Service Level (%): ",
        default: 100,
        actual: 100,
        min: 40,
        max: 160,
        step: 5,
        intensity: "primary",
        index: 1
      },
      ruleFilter: {
        label: 'Apply Rule',
        state: 'apply'
      },
      searchQuery: "",
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      gridColumnApi: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: "",
          field: "row",
          filter: false,
          width: 20,
          pinned: "left",
          // checkboxSelection: true,
          // headerCheckboxSelectionFilteredOnly: true,
          // headerCheckboxSelection: true
        },
        {
          headerName: "Store",
          field: "store_code",
          filter: true,
          filterParams: {
            clearButton: true,
            applyButton: true,
            debounceMs: 200
          },
          width: 150,
          unSortIcon: true,
          pinned: "left",
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          hide: true
        },
        {
          headerName: "Sku Id",
          field: "sku_id",
          filter: true,
          filterParams: {
            clearButton: true,
            applyButton: true,
            debounceMs: 200
          },
          unSortIcon: true,
          width: 250,
          hide: true
        },
        {
          headerName: "Sku",
          field: "long_description",
          filter: "agTextColumnFilter",
          filterParams: {
            clearButton: true,
            applyButton: true,
            debounceMs: 200
          },
          width: 400,
          unSortIcon: true,
          pinned: "left",
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          cellRenderer: (params) => {
              // console.log(params.data);
              return "<span style='color:#b8c2cc'><small>"+params.data.sku_id+ " / </small></span>" + params.value;
          }
        },
        {
          headerName: "Category",
          field: "product_category",
          filter: true,
          filterParams: {
            clearButton: true,
            applyButton: true,
            debounceMs: 200
          },
          unSortIcon: true,
          width: 250
        },
        {
          headerName: "Brand",
          field: "brand",
          filter: true,
          filterParams: {
            clearButton: true,
            applyButton: true,
            debounceMs: 200
          },
          unSortIcon: true,
          width: 250
        },
        {
          headerName: "Order",
          field: "quantity_in_cases",
          filter: "agNumberColumnFilter",
          filterParams: {
            clearButton: true,
            applyButton: true,
            debounceMs: 200
          },
          // sort: "desc",
          unSortIcon: true,
          width: 150
        },
        {
          headerName: "Override",
          field: "oqty",
          width: 150,
          filter: "agNumberColumnFilter",
          filterParams: {
            clearButton: true,
            applyButton: true,
            debounceMs: 200
          },
          unSortIcon: true,
          editable: true
        },
        {
          headerName: "Actual",
          field: "quantity_per_sku",
          filter: "agNumberColumnFilter",
          filterParams: {
            clearButton: true,
            applyButton: true,
            debounceMs: 200
          },
          sort: "desc",
          unSortIcon: true,
        },
        {
          headerName: "Units/Pack",
          field: "case_translation",
          filter: false,
          unSortIcon: true,
        },
        {
          headerName: "MOQ",
          field: "quantity",
          filter: false,
          unSortIcon: true,
        },                
        {
          headerName: "In Hand",
          field: "stock",
          filter: true,
          unSortIcon: true,
          width: 150
        },
        {
          headerName: "In Transit",
          field: "transit",
          filter: true,
          unSortIcon: true,
          width: 150
        },
        {
          headerName: "Ctc ( "+this.$options.filters.currencySymbol('')+" )",
          field: "ctc",
          filter: true,
          unSortIcon: true,
          width: 150
        }
      ],


      analyticsData: analyticsData,
      showStatsPanel: true,
      popupActive: false,
      colorx: "#e1e1e1",

      unitSelected: [],
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot"
      ],
      units: [],
      stores: {
        "ccb23788-2d92-11e1-8194-0015c5e16c09": "Cagueuyes",
        "ccb2363e-2d92-11e1-8194-0015c5e16c09": "Paradise ",
        "cc91c7e6-2d92-11e1-8194-0015c5e16c09": "Palero"
      },


      //Export Feature
      fileName: "PO Trigger @ "+this.$options.filters.dateFormat(new Date(), 'D MMM YYYY'),
      formats:["xlsx", "csv", "txt"] ,
      cellAutoWidth: true,
      selectedFormat: "xlsx",
      headerTitle: ["Row", "Store", "Sku Id","Sku", "Category", "Brand", "Order", "Override Qty."],
      headerVal: ["row", "store_code", "sku_id","long_description", "product_category", "brand", "quantity_in_cases", "oqty"],

    };
  },
  watch: {
    "$store.state.windowWidth"(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned("code", null);
      } else this.gridOptions.columnApi.setColumnPinned("code", "left");
    }
  },
  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 50;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      }
    },

    ...mapGetters({ order: "predictor/artefactUnit" })
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;

      this.gridApi.paginationSetPageSize(10);
    },
    onSelectionChanged() {
        const selectedNodes = this.gridApi.getSelectedNodes();
        const selectedData = selectedNodes.map( node => node.data );
        this.unitSelected = selectedData;
        this.orderValue = 0;//Math.floor(Math.random() * 101010101);
        // const selectedDataStringPresentation = selectedData.map( node => node.long_description + ' ' + node.product_category).join(', ');
        // alert(`Selected nodes: ${selectedDataStringPresentation}`);
    },
    actOnFilter(type, query, prop) {
      if(type !== 'refresh') {
        this.ruleFilter.state = type !== 'clear' ? 'clear' : 'apply';
        this.ruleFilter.label = type !== 'clear' ? 'Clear Rule' : 'Apply Rule';
      }

      if(type === 'apply' || (this.ruleFilter.state === 'clear' && type === 'refresh')) {
        
        var filterInstance = this.gridApi.getFilterInstance(prop);

        // number filter with one condition, with greaterThanOrEqual type
        var numberGreaterThanOrEqual = {
            filterType: 'number',
            type: 'greaterThanOrEqual',
            filter: 12
        };

        // set filter model and update
        filterInstance.setModel(numberGreaterThanOrEqual);

        // tell the grid to refresh rows based on the filter. The filter does
        // not do this automatically, allowing you to batch multiple filter
        // updates for performance
        this.gridApi.onFilterChanged();
        this.gridApi.selectAllFiltered();
      } else if(type === 'clear') {
        this.gridApi.deselectAllFiltered();
      }
      this.gridApi.destroyFilter(prop);
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    formatStoreOrder() {
      this.units = [];

      for (let i = 0; i < this.artefact.tags.length; i++) {
        let eachfilterAndSortData = this.filterAndSortData(
          this.artefact.tags[i],
          this.order.res.order
        );

        for (let j = 0; j < eachfilterAndSortData.length; j++) {
          let demandSkus = {};
          Object.assign(demandSkus, eachfilterAndSortData[j]);
          let oqty = Math.ceil(demandSkus.quantity_in_cases * this.serviceLevel.index);

          demandSkus.oqty = oqty < 0 ? 0 : oqty;
          // if (eachfilterAndSortData[j].oqty > 11) {
          //   this.handleSelected(eachfilterAndSortData[j]);
          // }
          this.units.push(demandSkus);
        }
      }
      this.actOnFilter('clear', '0', 'quantity_per_sku');
    },
    filterAndSortData(tag, data) {
      // console.log('filterAndSortData -> ', tag.tag, data[0]);

      // let filteredData = data;

      let filteredData = data.filter(
        t => tag.code === t.store_code || tag.tag === t.product_category
        // t => (t.store_code ? (tag.code === t.store_code) : (tag.tag === t.product_category))
      );

      return filteredData.sort(function(t1, t2) {
        return t2.quantity_in_cases - t1.quantity_in_cases;
      });
    },
    updateItemQuantity(event, index, tr) {
      // const itemIndex = Math.abs(index + 1);
      tr.oqty = event;

      this.handleSelected(tr);
      // if(!this.unitSelected.includes(tr) && (this.units[index].quantity_in_cases !== this.units[index].oqty)) {
      //   this.unitSelected.push(this.units[index]);
      // } else if(this.unitSelected.includes(tr) && (this.units[index].quantity_in_cases === this.units[index].oqty)) {
      //   this.unitSelected.splice(index, index+1);
      // }
    },
    showOverrideIndicator(data) {
      if (Number(data.oqty) !== Number(data.quantity_in_cases)) {
        if (Number(data.oqty) > Number(data.quantity_in_cases)) {
          return "success";
        } else {
          return "warning";
        }
      } else {
        return "primary";
      }
    },
    handleSelected(tr) {
      let selectedUnitIndex = this.findIndex(
        this.unitSelected,
        ["store_code", "sku_id"],
        tr
      );
      if (selectedUnitIndex < 0) {
        this.unitSelected.push(tr);
      } else if (selectedUnitIndex > -1 && tr.quantity_in_cases !== tr.oqty) {
        this.unitSelected.splice(selectedUnitIndex, 1);
        this.unitSelected.push(tr);
      } else if (selectedUnitIndex > -1 && tr.quantity_in_cases === tr.oqty) {
        this.unitSelected.splice(selectedUnitIndex, 1);
      }
    },
    applyState(tr, indextr) {
      return this.findIndex(this.unitSelected, ["store_code", "sku_id"], tr) >
        -1 || tr.quantity_in_cases !== tr.oqty
        ? "warning"
        : "";
    },
    findIndex(arr, keys, val) {
      return arr.findIndex(v => this.findMatch(v, keys, val));
    },
    findMatch(obj, keys, val) {
      let flag = true;
      for (var i = 0; i < keys.length; i++) {
        if (flag) {
          flag = obj[keys[i]] === val[keys[i]];
        } else {
          return false;
        }
      }

      return flag;
    },

    activatePopup() {
      if(this.popupActive) {
        return this.unitSelected;
      } else {
        return [];
      }
    },

    exportToExcel() {
      import('@/plugins/Export2Excel').then(excel => {
        const list = this.unitSelected
        const data = this.formatJson(this.headerVal, list)
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.clearFields()
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        // Add col name which needs to be translated
        // if (j === 'timestamp') {
        //   return parseTime(v[j])
        // } else {
        //   return v[j]
        // }

        return v[j]
      }))
    },
    clearFields() {
      this.fileName = ""
      this.cellAutoWidth = true
      this.selectedFormat = "xlsx"
    },
    applyServiceLevel() {
      /*
      this.$vs.loading({
        // background: this.backgroundLoading,
        // color: this.colorLoading,
        container: "#order-panel",
        // scale: 0.45,
        type: "radius"
      });
      */


      this.serviceLevel.intensity = "primary";
      if(this.serviceLevel.actual > this.serviceLevel.default) {
        this.serviceLevel.intensity = "danger";
      } else if(this.serviceLevel.actual < this.serviceLevel.default) {
        this.serviceLevel.intensity = "warning";
      }

      this.serviceLevel.index = (Number(this.serviceLevel.actual) + (Number(this.serviceLevel.actual) - this.serviceLevel.default))/ 100;
      console.log('applyServiceLevel', this.serviceLevel);

      this.formatStoreOrder();

      // this.$vs.loading.close("#order-panel > .con-vs-loading");

    }    
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    this.formatStoreOrder();
  },
  components: {
    AgGridVue,
    VueApexCharts,
    StatisticsCardLine,
    Pobill
  }
};
</script>

<style lang="scss">
  @import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
</style>
